const IconOpportunities = ({ className }) => {
    return (
        <svg
            width='32'
            height='48'
            viewBox='0 0 32 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g id='opportunities/bulb/icon' clipPath='url(#clip0_3983_31475)'>
                <path
                    id='Vector'
                    d='M11.9998 35.7332H19.9993M13.333 41.3332H18.6661M20.1193 30.1333C20.3593 28.7613 20.9859 27.6973 21.9992 26.6333C22.643 26.011 23.154 25.2526 23.4987 24.4081C23.8434 23.5635 24.0139 22.6519 23.9991 21.7333C23.9991 19.5054 23.1563 17.3689 21.6561 15.7936C20.1559 14.2182 18.1212 13.3333 15.9996 13.3333C13.8779 13.3333 11.8432 14.2182 10.343 15.7936C8.84281 17.3689 8 19.5054 8 21.7333C8 23.1333 8.30665 24.8553 9.99989 26.6333C10.9652 27.5601 11.6238 28.7863 11.8798 30.1333'
                    stroke='white'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_2'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16 2.66675C16.8837 2.66675 17.6 3.42651 17.6 4.36372V6.06069C17.6 6.9979 16.8837 7.75766 16 7.75766C15.1163 7.75766 14.4 6.9979 14.4 6.06069V4.36372C14.4 3.42651 15.1163 2.66675 16 2.66675ZM4.62863 7.5759C5.25347 6.91319 6.26653 6.91319 6.89137 7.5759L8.01137 8.76378C8.63621 9.42649 8.63621 10.5009 8.01137 11.1637C7.38653 11.8264 6.37347 11.8264 5.74863 11.1637L4.62863 9.97578C4.00379 9.31307 4.00379 8.23861 4.62863 7.5759ZM27.3714 7.5759C27.9962 8.23861 27.9962 9.31307 27.3714 9.97578L26.2514 11.1637C25.6265 11.8264 24.6135 11.8264 23.9886 11.1637C23.3638 10.501 23.3638 9.42649 23.9886 8.76378L25.1086 7.5759C25.7335 6.91319 26.7465 6.91319 27.3714 7.5759ZM0 19.6364C0 18.6992 0.716344 17.9395 1.6 17.9395H3.2C4.08366 17.9395 4.8 18.6992 4.8 19.6364C4.8 20.5737 4.08366 21.3334 3.2 21.3334H1.6C0.716344 21.3334 0 20.5737 0 19.6364ZM27.2 19.6364C27.2 18.6992 27.9163 17.9395 28.8 17.9395H30.4C31.2837 17.9395 32 18.6992 32 19.6364C32 20.5737 31.2837 21.3334 30.4 21.3334H28.8C27.9163 21.3334 27.2 20.5737 27.2 19.6364Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_3983_31475'>
                    <rect width='32' height='48' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconOpportunities;
